import { template } from 'lodash-es';
import { type TConfigEnv } from '@/services/ConfigService';

let appEnvironment: TConfigEnv | null = null;

export const provideAppEnvironment = (appEnv: TConfigEnv): void => {
  appEnvironment = appEnv;
};

export const getAppEnvironment = (): TConfigEnv => {
  if (!appEnvironment) {
    throw new Error('App environment is not provided');
  }

  return appEnvironment;
};

// api/:param => api/qwerty
// api/{param} => api/qwerty
export const makeURL = (urlTemplate: string, params: Record<string, string | number>): string => {
  const finalTpl = urlTemplate.replace(/\/(:[^/]+)/g, '/{$1}'); // `api/:param` => `api/{param}`

  return template(finalTpl, { interpolate: /{([\s\S]+?)}/g })(params);
};
